import type { CellData } from "./types";

export const nextCell = (currentCell: string) => {
  const match = currentCell.match(/^([A-Z]+)(\d+)$/);

  if (!match) return null;

  let column = match[1];
  const row = match[2];

  let i = column.length - 1;
  while (i >= 0) {
    if (column[i] === "Z") {
      column = `${column.substring(0, i)}A${column.substring(i + 1)}`;
      if (i === 0) {
        column = `A${column}`;
      }
      i--;
    } else {
      column = column.substring(0, i) + String.fromCharCode(column.charCodeAt(i) + 1) + column.substring(i + 1);
      break;
    }
  }

  return `${column}${row}`;
};

export const excelSerialDateToJSDate = (serial: number): Date => {
  // Excelの日付は1900年1月1日を基準としてカウントされている
  const excelEpoch = new Date(1899, 11, 30); // 1899年12月30日が基準
  const daysOffset = serial; // シリアル値分の日数を追加
  const jsDate = new Date(excelEpoch.getTime() + daysOffset * 24 * 60 * 60 * 1000);
  return jsDate;
};

export const getLastDayOfMonth = (cellData: CellData) => {
  const dateCell = cellData.B6;
  const date = excelSerialDateToJSDate(Number(dateCell.value));
  const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  return lastDayOfMonth;
};

export const getCasNaviIdAndName = (comment: string) => {
  const regex = /現場： \((\d+)\) (.+)/;
  const match = comment.match(regex);
  if (match) {
    const casNaviId = Number.parseInt(match[1], 10).toString();
    return [casNaviId, match[2]];
  }
  return [null, null];
};

export const getCasNaviIdAndNameFromValue = (value: string) => {
  // Handle format like "1234：ソプラタワー" or "1234：ソプラタワー/【早番】"
  const regex = /^(\d+)：([^/]+)(?:\/(.+))?/;
  const match = value.match(regex);
  if (match) {
    const casNaviId = match[1];
    const buildingName = match[2];
    const shiftType = match[3]; // This will be like "【早番】" if present
    return [casNaviId, buildingName, shiftType];
  }
  return [null, null, null];
};

export const excelSerialDateToYYYYMM = (serial: number): string => {
  const date = excelSerialDateToJSDate(serial);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 月を2桁にフォーマット
  return `${year}${month}`;
};
